// tslint:disable
export var RoleType;
(function (RoleType) {
    // UNKN
    RoleType[RoleType["Unknown"] = 0] = "Unknown";
    // PAT
    RoleType[RoleType["Patient"] = 1] = "Patient";
    // PSRB
    RoleType[RoleType["Prescriber"] = 2] = "Prescriber";
    // INS
    RoleType[RoleType["InsuranceProvider"] = 3] = "InsuranceProvider";
    // PBM
    RoleType[RoleType["PharmacyBenefitManager"] = 4] = "PharmacyBenefitManager";
    // SEC
    RoleType[RoleType["SecondaryContact"] = 5] = "SecondaryContact";
    // MFT
    RoleType[RoleType["Manufacturer"] = 6] = "Manufacturer";
    // EMP
    RoleType[RoleType["EMP"] = 7] = "EMP";
    // CSR
    RoleType[RoleType["CustomerServiceRep"] = 8] = "CustomerServiceRep";
    // PSRBSITE
    RoleType[RoleType["PrescriberSite"] = 9] = "PrescriberSite";
    // BRAND
    RoleType[RoleType["Brand"] = 10] = "Brand";
    // CHLD
    RoleType[RoleType["Child"] = 11] = "Child";
    // SCWRK
    RoleType[RoleType["SocialWorker"] = 12] = "SocialWorker";
    // FINREP
    RoleType[RoleType["FinancialRepresentative"] = 13] = "FinancialRepresentative";
    // LGLREP
    RoleType[RoleType["LegalRepresentative"] = 14] = "LegalRepresentative";
    // COR
    RoleType[RoleType["Corporate"] = 15] = "Corporate";
    // PERCNT
    RoleType[RoleType["PersonalContact"] = 16] = "PersonalContact";
    // SPOUSE
    RoleType[RoleType["Spouse"] = 17] = "Spouse";
    // PARENT
    RoleType[RoleType["Parent"] = 18] = "Parent";
    // HMHEALTH
    RoleType[RoleType["HomeHealth"] = 19] = "HomeHealth";
    // ALTCNT
    RoleType[RoleType["AlternateContact"] = 20] = "AlternateContact";
    // AUTOINJ
    RoleType[RoleType["AutoInjuryPlan"] = 21] = "AutoInjuryPlan";
    // COMMPL
    RoleType[RoleType["CommercialPlan"] = 22] = "CommercialPlan";
    // FEDPL
    RoleType[RoleType["FederalEmployeeProgram"] = 23] = "FederalEmployeeProgram";
    // MEDAD
    RoleType[RoleType["Medicaid"] = 24] = "Medicaid";
    // MDCRAD
    RoleType[RoleType["MedicareAdvantage"] = 25] = "MedicareAdvantage";
    // MDCRB
    RoleType[RoleType["MedicareB"] = 26] = "MedicareB";
    // MDCRD
    RoleType[RoleType["MedicareD"] = 27] = "MedicareD";
    // MDGP
    RoleType[RoleType["MediGap"] = 28] = "MediGap";
    // VATC
    RoleType[RoleType["VADoDTRICARE"] = 29] = "VADoDTRICARE";
    // WRKCMP
    RoleType[RoleType["WorkersCompensation"] = 30] = "WorkersCompensation";
    // PLAN
    RoleType[RoleType["Plan"] = 31] = "Plan";
    // PAYER
    RoleType[RoleType["Payer"] = 32] = "Payer";
    // DMEP
    RoleType[RoleType["DurableMedicalEquiqmentPlan"] = 33] = "DurableMedicalEquiqmentPlan";
    // MCMP
    RoleType[RoleType["ManagedCareMedicaidPlan"] = 34] = "ManagedCareMedicaidPlan";
    // SPAP
    RoleType[RoleType["StatePharmacyAssistanceProgram"] = 35] = "StatePharmacyAssistanceProgram";
    // MEDAB
    RoleType[RoleType["MedicarePartABPlan"] = 36] = "MedicarePartABPlan";
    // ADAP
    RoleType[RoleType["AidsDrugAssistanceProgram"] = 37] = "AidsDrugAssistanceProgram";
    // STPL
    RoleType[RoleType["StatePlan"] = 38] = "StatePlan";
    // PRVD
    RoleType[RoleType["Provider"] = 39] = "Provider";
    // EPO
    RoleType[RoleType["ExclusiveProviderOrganization"] = 40] = "ExclusiveProviderOrganization";
    // INDEM
    RoleType[RoleType["IndemnityInsurance"] = 41] = "IndemnityInsurance";
    // HMO
    RoleType[RoleType["HealthMaintenanceOrganization"] = 42] = "HealthMaintenanceOrganization";
    // POSP
    RoleType[RoleType["PointOfServicePlan"] = 43] = "PointOfServicePlan";
    // PPO
    RoleType[RoleType["PreferredProviderOrganization"] = 44] = "PreferredProviderOrganization";
    // SELF
    RoleType[RoleType["Self"] = 45] = "Self";
    // OFFCNT
    RoleType[RoleType["OfficeContact"] = 46] = "OfficeContact";
    // PHARM
    RoleType[RoleType["Pharmacy"] = 47] = "Pharmacy";
    // MDCRA
    RoleType[RoleType["MedicareA"] = 48] = "MedicareA";
    // HOSP
    RoleType[RoleType["Hospital"] = 49] = "Hospital";
    // HOSPOP
    RoleType[RoleType["HospitalOutpatient"] = 50] = "HospitalOutpatient";
    // INFCTR
    RoleType[RoleType["InfusionCenter"] = 51] = "InfusionCenter";
    // RETPHAR
    RoleType[RoleType["RetailPharmacy"] = 52] = "RetailPharmacy";
    // Foundation
    RoleType[RoleType["Foundation"] = 53] = "Foundation";
    // SecSupp
    RoleType[RoleType["SecondarySupplemental"] = 54] = "SecondarySupplemental";
    // RegNurse
    RoleType[RoleType["RegisteredNurse"] = 55] = "RegisteredNurse";
    // LicPractNurse
    RoleType[RoleType["LicensedPracticalNurse"] = 56] = "LicensedPracticalNurse";
    // CertNursingAsst
    RoleType[RoleType["CertifiedNursingAssistant"] = 57] = "CertifiedNursingAssistant";
    // MedAsst
    RoleType[RoleType["MedicalAssistant"] = 58] = "MedicalAssistant";
    // NatlHealthAgncy
    RoleType[RoleType["NationalHomeHealthAgency"] = 59] = "NationalHomeHealthAgency";
    // IndlHealthAgncy
    RoleType[RoleType["IndependentHomeHealthAgency"] = 60] = "IndependentHomeHealthAgency";
    // Practice
    RoleType[RoleType["Practice"] = 61] = "Practice";
    // PDCI
    RoleType[RoleType["PerDiemContractIndividual"] = 62] = "PerDiemContractIndividual";
    // Employee
    RoleType[RoleType["Employee"] = 63] = "Employee";
})(RoleType || (RoleType = {}));
RoleType['UNKNOWN'] = 0;
RoleType['PATIENT'] = 1;
RoleType['PRESCRIBER'] = 2;
RoleType['INSURANCEPROVIDER'] = 3;
RoleType['PHARMACYBENEFITMANAGER'] = 4;
RoleType['SECONDARYCONTACT'] = 5;
RoleType['MANUFACTURER'] = 6;
RoleType['CUSTOMERSERVICEREP'] = 8;
RoleType['PRESCRIBERSITE'] = 9;
RoleType['BRAND'] = 10;
RoleType['CHILD'] = 11;
RoleType['SOCIALWORKER'] = 12;
RoleType['FINANCIALREPRESENTATIVE'] = 13;
RoleType['LEGALREPRESENTATIVE'] = 14;
RoleType['CORPORATE'] = 15;
RoleType['PERSONALCONTACT'] = 16;
RoleType['SPOUSE'] = 17;
RoleType['PARENT'] = 18;
RoleType['HOMEHEALTH'] = 19;
RoleType['ALTERNATECONTACT'] = 20;
RoleType['AUTOINJURYPLAN'] = 21;
RoleType['COMMERCIALPLAN'] = 22;
RoleType['FEDERALEMPLOYEEPROGRAM'] = 23;
RoleType['MEDICAID'] = 24;
RoleType['MEDICAREADVANTAGE'] = 25;
RoleType['MEDICAREB'] = 26;
RoleType['MEDICARED'] = 27;
RoleType['MEDIGAP'] = 28;
RoleType['VADODTRICARE'] = 29;
RoleType['WORKERSCOMPENSATION'] = 30;
RoleType['PLAN'] = 31;
RoleType['PAYER'] = 32;
RoleType['DURABLEMEDICALEQUIQMENTPLAN'] = 33;
RoleType['MANAGEDCAREMEDICAIDPLAN'] = 34;
RoleType['STATEPHARMACYASSISTANCEPROGRAM'] = 35;
RoleType['MEDICAREPARTABPLAN'] = 36;
RoleType['AIDSDRUGASSISTANCEPROGRAM'] = 37;
RoleType['STATEPLAN'] = 38;
RoleType['PROVIDER'] = 39;
RoleType['EXCLUSIVEPROVIDERORGANIZATION'] = 40;
RoleType['INDEMNITYINSURANCE'] = 41;
RoleType['HEALTHMAINTENANCEORGANIZATION'] = 42;
RoleType['POINTOFSERVICEPLAN'] = 43;
RoleType['PREFERREDPROVIDERORGANIZATION'] = 44;
RoleType['SELF'] = 45;
RoleType['OFFICECONTACT'] = 46;
RoleType['PHARMACY'] = 47;
RoleType['MEDICAREA'] = 48;
RoleType['HOSPITAL'] = 49;
RoleType['HOSPITALOUTPATIENT'] = 50;
RoleType['INFUSIONCENTER'] = 51;
RoleType['RETAILPHARMACY'] = 52;
RoleType['FOUNDATION'] = 53;
RoleType['SECONDARYSUPPLEMENTAL'] = 54;
RoleType['REGISTEREDNURSE'] = 55;
RoleType['LICENSEDPRACTICALNURSE'] = 56;
RoleType['CERTIFIEDNURSINGASSISTANT'] = 57;
RoleType['MEDICALASSISTANT'] = 58;
RoleType['NATIONALHOMEHEALTHAGENCY'] = 59;
RoleType['INDEPENDENTHOMEHEALTHAGENCY'] = 60;
RoleType['PRACTICE'] = 61;
RoleType['PERDIEMCONTRACTINDIVIDUAL'] = 62;
RoleType['EMPLOYEE'] = 63;
//# sourceMappingURL=RoleType.js.map